var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar',[_c('template',{slot:"sidebar-header"},[_c('div',{staticClass:"sidebar-muted"},[_vm._v("Exercícios por disciplina")])]),_c('template',{slot:"sidebar-bottom"},[(_vm.user)?_c('feedback'):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }